import { PATHS } from '@routing/routes';
import { Alert, Button, Col, Form, Modal, Row, Table, message } from 'antd';
import { Constants } from 'common/constants';
import { DeleteBarcodeRequest } from 'common/models/ContainerTypes';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { InterStateSelector } from '../store/InterStateSelector';
import { OperationStatus } from 'store/rootTypes';
import {
  DeleteInterStateBarcode,
  GetInterStateBarcodeDetails,
  LoadBarcodeInterState,
} from '../business/InterStateBusiness';
import { useEffect, useState } from 'react';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { InterStateBarcodeViewModel, UploadBarcodeInterStateRequest } from 'common/models/InterStateTypes';
import TextArea from 'antd/es/input/TextArea';
import { GetHeaders } from '@features/Common';
import { apibaseUrl } from 'common/utils/jsonFetch';
import { KFSEndpoints } from 'common/constants/KFSEndpoints';
export const InterStateLoading = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const interState = useSelector(InterStateSelector);
  let data: InterStateBarcodeViewModel[] = interState.InterStateBarcodeList || [];

  const onFinish = async (values: UploadBarcodeInterStateRequest) => {
    values.InterStateId = interState.InterState?.Id ?? '';
    await dispatch(LoadBarcodeInterState(values));
    if (interState.InterState?.Id) {
      await dispatch(GetInterStateBarcodeDetails(interState.InterState?.Id));
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      if (interState?.SelectedInterStateId) {
        await dispatch(GetInterStateBarcodeDetails(interState?.SelectedInterStateId));
      }
    };

    fetchData();

    data = interState.InterStateBarcodeList || [];
  }, []);

  useEffect(() => {
    data = interState.InterStateBarcodeList || [];
  }, [interState.InterStateBarcodeList]);

  const columns = [
    {
      title: 'Name',
      dataIndex: 'SenderName',
      key: 'SenderName',
    },
    {
      title: 'Reference no',
      dataIndex: 'RefNo',
      key: 'RefNo',
      render: (text, record) => <span className={record.IsFlag ? 'isFlagTrue' : ''}>{record.RefNo}</span>,
    },
    {
      title: 'Barcode no',
      dataIndex: 'BarcodeNo',
      key: 'BarcodeNo',
    },
    {
      title: 'Delete',
      dataIndex: 'Id',
      key: 'Id',
      render: (text, record) => (
        <a
          onClick={() =>
            handleDeleteClick({
              Id: record.Id,
              TransactionId: record.TransactionId,
            })
          }
        >
          Delete barcode
        </a>
      ),
    },
  ];
  const [deleteBarcodeRequest, setDeleteBarcodeRequest] = useState<DeleteBarcodeRequest>();
  const handleDeleteClick = async (data: DeleteBarcodeRequest) => {
    setDeleteBarcodeRequest(data);
  };
  useEffect(() => {
    if (deleteBarcodeRequest !== undefined) {
      showConfirm();
    }
  }, [deleteBarcodeRequest]);

  const { confirm } = Modal;

  const showConfirm = () => {
    confirm({
      title: 'Do you want to delete this barcode?',
      icon: <ExclamationCircleFilled />,
      content: '',
      okText: 'No',
      cancelText: 'Yes',
      okButtonProps: { className: 'ant-btn-default-okcancelbooking' },
      cancelButtonProps: { className: 'ant-btn-primary' },
      async onCancel() {
        if (deleteBarcodeRequest) {
          await dispatch(DeleteInterStateBarcode(deleteBarcodeRequest));
          if (interState.SelectedInterStateId) {
            await dispatch(GetInterStateBarcodeDetails(interState.SelectedInterStateId));
          }
        } else {
          message.warning('No barcode selected. Please select');
        }
      },
      async onOk() {
        //conso
      },
    });
  };

  const generateExcel = async () => {
    try {
      const apiHeaders = await GetHeaders(apibaseUrl + KFSEndpoints.InterState_GenerateExcel);
      const url1 = `${apibaseUrl + KFSEndpoints.InterState_GenerateExcel}?id=${interState.SelectedInterStateId}`;
      const response = await fetch(url1, {
        method: 'GET',
        headers: apiHeaders,
      });
      const blob = await response.blob();
      // Create a download link and trigger a download
      const url = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement('a');
      link.href = url;
      const formattedDate = 'Interstate -' + interState.InterState?.TrfId + '.xlsx';
      link.setAttribute('download', formattedDate);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error('Error generating Excel file', error);
    }
  };
  return (
    <div className="App">
      <Row justify="center" align="middle">
        <h1>Interstate load barcode</h1>
      </Row>

      <Form name="containerForm" onFinish={onFinish} form={form} layout="vertical">
        <br />
        <Row>
          <Col xs={24} sm={20} md={10} lg={8} xl={4} className="textColor">
            <p>
              <b>Interstate id: </b> {interState.InterState?.TrfId}
            </p>
          </Col>
          <Col xs={24} sm={20} md={10} lg={8} xl={4} className="textColor">
            <p>
              Number of box(es) loaded: <b>{interState.InterState?.BoxCount}</b>
            </p>
          </Col>
        </Row>
        <hr />
        <br />
        <Row>
          <Col xs={24} sm={24} md={24} lg={24} xl={12}>
            <Form.Item
              label={
                <span>
                  Insert barcode number(s) here. You can enter one or multiple barcodes.
                  <br />
                  Please follow the correct format (e.g., NSW995742S, NSW467106S). New lines are allowed.
                  <br />
                </span>
              }
              name="Barcodes"
              rules={[{ required: true, message: Constants.REQUIRED_FIELD }]}
            >
              <TextArea size="large" maxLength={500} rows={5} />
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col xs={24} sm={24} md={24} lg={24} xl={12}>
            {interState?.UploadBarcodeResponse?.IsSuccess && (
              <>
                <Alert message="Barcode(s) successfully uploaded." type="success" showIcon />
                <br />
              </>
            )}

            {interState?.UploadBarcodeResponse?.IsSuccess == false && (
              <>
                <Alert message={interState?.UploadBarcodeResponse?.Message} type="error" showIcon />
                <br />
              </>
            )}
          </Col>
        </Row>

        <Row gutter={[10, 0]}>
          <Col xs={24} sm={20} md={12} lg={10} xl={10}>
            <Button
              className="prevSenderBtn"
              size="large"
              type="default"
              loading={interState.submitStatus == OperationStatus.pending}
              onClick={() =>
                interState.IsFromListing
                  ? history.push(PATHS.InterStateListing.path)
                  : history.push(PATHS.InterStateProfile.path)
              }
            >
              {Constants.BTN_BACK}
            </Button>
            <Button
              className="nextSenderBtn"
              size="large"
              type="primary"
              htmlType="submit"
              loading={interState.submitStatus == OperationStatus.pending}
            >
              Save
            </Button>
          </Col>
        </Row>
        <br />
        <br />
        {data && data.length > 0 && (
          <Button
            className="prevSenderBtn downloadExceltTransaction"
            size="middle"
            type="primary"
            onClick={generateExcel}
          >
            Download
          </Button>
        )}
        <Table dataSource={data} columns={columns} pagination={{ pageSize: 100 }} />
      </Form>
    </div>
  );
};
